import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_ADDITIONAL_USERS](state, data) {
    state.allAdditionalUsers = data
  },
  [types.SAVE_ADDITIONAL_USER](state, data) {
    state.additionalUser.push(data)
  },
}
